import React from 'react'
import { Sparkles, X, ExternalLink } from 'lucide-react'

const TrialBanner = ({ onUpgrade, onDismiss }) => {
  return (
    <div className="bg-gradient-to-r from-amber-500 via-orange-500 to-pink-500 text-white px-4 py-2 text-sm flex items-center justify-center gap-3 relative">
      <Sparkles className="h-4 w-4 flex-shrink-0" />
      <span className="font-medium">
        Du bist in einer Demo-Sandbox. Deine Änderungen bleiben isoliert und werden mit dem Schließen des Tabs gelöscht.
      </span>
      <button
        onClick={onUpgrade}
        className="bg-white text-orange-600 px-3 py-1 rounded-full text-xs font-bold hover:bg-orange-50 transition-colors flex items-center gap-1"
      >
        Account erstellen <ExternalLink className="h-3 w-3" />
      </button>
      {onDismiss && (
        <button onClick={onDismiss} className="absolute right-2 top-1/2 -translate-y-1/2 hover:opacity-75">
          <X className="h-4 w-4" />
        </button>
      )}
    </div>
  )
}

export default TrialBanner
